export const appCategories = [
  { value: "all", label: "All Apps" },
  { value: "my-apps", label: "My Apps" },
  { value: "automation", label: "Automation" },
  { value: "notifications", label: "Notifications" },
  { value: "scheduling", label: "Scheduling" },
  { value: "pending", label: "Pending" }
];